<i18n>
{
	"en": {
		"add": "Added",
		"remove": "Removed",
		"viaLocation": "Via Location",
		"dateTimeTitle": "Planned Date and Time",
		"contactEmail": "Email",
		"contactName": "Contact Name",
		"contactPhone": "Phone Number",
		"country": "Country",
		"countryCode": "Country Code",
		"name": "Name",
		"organizationNumber": "Organization Number",
		"postalCode": "Postal Code",
		"postalPlace": "Postal Place",
		"street": "Street",
		"isTerminal": "Terminal"
	},
	"no": {
		"add": "Laget",
		"remove": "Slettet",
		"viaLocation": "Via Sted",
		"dateTimeTitle": "Planlagt dato og tid",
		"contactEmail": "E-post",
		"contactName": "Kontaktens navn",
		"contactPhone": "Telefon",
		"country": "Land",
		"countryCode": "Landkode",
		"name": "Navn",
		"postalCode": "Postnummer",
		"postalPlace": "Poststed",
		"street": "Gate",
		"isTerminal": "Terminal"
	}
}
</i18n>
<template>
	<t-vertical-panel>
		<div slot="header" class="details-header">
			<t-panel-header icon="undefined" :text="$t('viaLocation')"/>
			<div class="details-header-sub-label" v-text="$t(op)"/>
			<t-icon-button
				style="margin-right: 10px;"
				appearance="minimal"
				type="bp"
				icon="cross"
				iconSize="md"
				@click="$emit('close')"
			/>
		</div>
		<div class="content">
			<t-pane v-bind="paneOptions">
				<div class="content-data">
					<TLabeledValue
						:label="$t('dateTimeTitle')"
						:value="getStorageDate(data.dateTimeObject.date)"
						labelMarginBottom="5px"
					/>
					<TLabeledValue
						:label="$t('name')"
						:value="data.address.name"
						labelMarginBottom="5px"
						style="grid-column: 1/3"
					/>
					<TLabeledValue
						:label="$t('street')"
						:value="data.address.street"
						labelMarginBottom="5px"
						style="grid-column: 1/3"
					/>
					<TLabeledValue
						:label="$t('postalCode')"
						:value="data.address.postalCode"
						labelMarginBottom="5px"
					/>
					<TLabeledValue
						:label="$t('postalPlace')"
						:value="data.address.postalPlace"
						labelMarginBottom="5px"
					/>
					<TLabeledValue
						:label="$t('countryCode')"
						:value="data.address.countryCode"
						labelMarginBottom="5px"
					/>
					<t-checkbox
						:label="$t('isTerminal')"
						:checked="data.isTerminal"
						disabled
					/>
					<TLabeledValue
						:label="$t('contactName')"
						:value="data.address.contactName"
						labelMarginBottom="5px"
					/>
					<TLabeledValue
						:label="$t('contactPhone')"
						:value="data.address.contactPhone"
						labelMarginBottom="5px"
					/>
					<TLabeledValue
						:label="$t('contactEmail')"
						:value="data.address.contactEmail"
						labelMarginBottom="5px"
					/>
				</div>
			</t-pane>
		</div>
	</t-vertical-panel>
</template>

<script>
import { storageDateFormat } from '@/core';
import moment from 'moment';

export default {
	name: 'ViaLocation',
	props: {
		field: String,
		data: Object,
		op: String
	},
	data() {
		return {
			paneOptions: {
				border: 'default',
				background: 'tint1',
				borderRadius: '5px',
				style: { padding: '5px', }
			},
		};
	},
	methods: {
		getStorageDate(date) {
			if (!date) return '';
			return moment(date, storageDateFormat).format('DD.MM.YYYY HH:mm');
		},
	}
};
</script>
<style lang="scss" scoped>
.content {
	margin: 10px;
}
.content-data {
	display: grid;
	grid-template-columns: repeat(2, minmax(150px, 1fr));
	column-gap: 20px;
	row-gap: 20px;
}
.details-header {
	height: 100%;
	display:flex;
	align-items: center;
	padding-left: 5px;
	.details-header-sub-label {
		flex: 1;
		color: #66788a;
		font-size: 14px;
	}
}
</style>